import script from "./SeoView.vue?vue&type=script&lang=js"
export * from "./SeoView.vue?vue&type=script&lang=js"

import "./SeoView.vue?vue&type=style&index=0&id=67438065&lang=scss"

const __exports__ = script;

export default __exports__